import React, { useState} from 'react'
import axios from "axios";
import ProfileModal from "./../Modals/ProfileModal";
import {useHistory} from "react-router-dom";
import ChatLoading from "../ChatLoading";
import { getSender } from "../../config/ChatLogics";
import UserListItem from "../userAvatar/UserListItem";
import {ChatState} from "../../Context/ChatProvider";
import Bellicon from "./../../images/Bellicon";
import Tooltip from "../../utils/Tooltip/Tooltip";
import Closeicon from "../../images/Closeicon";
import SpinnerCustom from "../SpinnerCustom";
import { getCsrfToken } from '../../utils/functions';

const SideDrawer = () => {
    const [search, setSearch] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingChat, setLoadingChat] = useState(false);
    const [openNotifications, setOpenNotifications] = useState(false);
    const {openAvatar, setOpenAvatar, user, setUser, setSelectedChat, chats, setChats, notification, setNotification, setOpenProfileModal, encryption, setEncryption, showToast, sounds, setSounds, installApp,    setInstallApp, infoIsOpen, setInfoIsOpen } = ChatState();
    const [drawerOpenClose, setDrawerOpenClose] = useState("close");
    const [settings, setSettings] = useState(true);
    const history = useHistory();
    const logoutHandler = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/user/logout`);
        } catch (error) {
            console.error("LogOut error:", error.message);
        } finally {
            setUser(null);
            localStorage.removeItem("userInfo");
            history.push("/");
        }
    };
    const handleSearch = async () => {
        if (!search) {
            showToast ('warning', 'Search is absent. Please enter something in search.')
            return;
        }
        if (search.match(/[<>&]/)) {
            showToast('warning', 'Please avoid using <, >, & characters.');
            return
        }
        if (search.length < 5) {
            showToast ('warning', ' Enter at least 5 characters.'   );
            return
        }
        try {
            setLoading(true);
            const config = { headers: { Authorization: `Bearer ${user.token}` } };
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/user?search=${search}`, config);
            setLoading(false);
            setSearchResult(data);
        } catch (error) {
            showToast ('info', error.message  || "can not access property description " );
        }
    }

    const accessChat = async (userId) => {
        if (loadingChat) return;
        try {
            setLoadingChat(true);
            const tokenFromCookie = getCsrfToken();
            const config = {
                headers: { "Content-type": "application/json", 
                    Authorization: `Bearer ${user.token}`,
                    "x-xsrf-token": tokenFromCookie
                }
            };
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/chat`, { userId }, config);
            if (!chats.find((c) => c._id === data._id)) setChats([data, ...chats]);
            setSelectedChat(data);
            setLoadingChat(false);
            setDrawerOpenClose("close");
        } catch (error) {
            showToast ( 'danger', 'Error fetching chat' );
        } finally{
            setLoadingChat(false);
        }
    }

    let timer;
    const toggleNotifications = () => {
        setOpenNotifications(!openNotifications);
        setOpenAvatar(false); 

        // If we are opening notifications, set a timer to close them after 8 seconds
        if (!openNotifications) {
            timer = setTimeout(() => {
                setOpenNotifications(false);
            }, 8000);
        } else {
            // If we are closing notifications manually, clear the timer
            clearTimeout(timer);
        }
    };
    const setInfoIsOpenFunction = (value) => {
        setInfoIsOpen(value);
        if (value)  {
            setOpenAvatar(false); // Close avatar menu when info is opened
        }
    };
        return (
        <>
            <div  className='chats_header'>
                <Tooltip content="Search Users" direction="bottom">
                    <button className='search_button' variant="ghost" onClick={()=>setDrawerOpenClose("open")} >
                        <i className="fas fa-search"></i>
                        <p className = 'searchUser'>
                            Search User
                        </p>
                    </button>
                </Tooltip>
                <h2 fontSize="2xl" fontFamily="Work sans">
                    <span><img src="/images/logo192.png" alt="SICH"/></span><span>SICH</span>
                </h2>
                <div className='rightMenu'>
                    <div className = 'notification_menu'  >
                        <button className='notification icon_button' onClick={()=>{toggleNotifications(); setOpenAvatar(false);}}>
                            <Bellicon className = '' focusable="false" aria-hidden="true" />
                            {notification.length === 0 ? null : <span className='icon_button_notification'>{notification.length}</span>}
                        </button>
                        {openNotifications &&
                            <ul className='list_menu'>
                                {!notification.length && <li className='listElement'><button className='myProfile'>"No New Messages"</button></li>}
                                {notification.map((notif) => (
                                    <li className='listElement'>
                                        <button className='myProfile'
                                            key={notif._id}
                                                tabindex="-1"
                                            onClick={() => {
                                                setSelectedChat(notif.chat);
                                                setNotification(notification.filter((n) => n !== notif));
                                            }}
                                        >
                                            {notif.chat.isGroupChat
                                                ? `New Message in ${notif.chat.chatName}`
                                                : `New Message from ${getSender(user, notif.chat.users)}`}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        }
                    </div>
                    <div className='avatar_block'>
                        <button className='avatar_button' onClick={()=>{setOpenAvatar(!openAvatar); setOpenNotifications(false)}}>
                            <span className='span_avatar'>
                                <img className='imgAvatar' alt='ava2' name={user.name} src={user.pic} />
                            </span>
                        </button>
                        { openAvatar && <>
                            <div className='modalOverlay' onClick={()=>setOpenAvatar(false)}></div>
                            <ul className='list_menu'>
                            <li className='listElement'>
                                <ProfileModal user={user} setOpenProfileModal={setOpenProfileModal} setOpenAvatar={setOpenAvatar} >
                                    <button onClick={()=>setOpenProfileModal(true)}   className='myProfile' >My Profile</button>
                                </ProfileModal>
                            </li>
                            <li className='listElement'>
                                <button  className='myProfile' onClick={()=>setSettings(!settings)} >Settings</button>
                                <div className={`myProfile_settings ${settings ? 'active' : '' }`}>
                                    <span className='settings_item'>
                                        <span >Info</span>
                                        <label className='switch'>
                                            <input type = 'checkbox' className='switch-input' checked={infoIsOpen} onChange = {()=>setInfoIsOpenFunction(!infoIsOpen)}/>
                                            <span className='switch-slider'></span>
                                        </label>
                                    </span>
                                    <span className='settings_item'>
                                        <span >Encryption</span>
                                        <label className='switch'>
                                            <input type = 'checkbox' className='switch-input' checked={encryption} onChange = {()=>setEncryption(!encryption)}/>
                                            <span className='switch-slider'></span>
                                        </label>
                                    </span>
                                    <span className='settings_item'>
                                        <span >Sounds</span>
                                        <label className='switch'>
                                            <input type = 'checkbox' className='switch-input' checked={sounds} onChange = {()=>setSounds(!sounds)}/>
                                            <span className='switch-slider'></span>
                                        </label>
                                    </span>
                                    <span className='settings_item'>
                                        <span >Install App</span>
                                        <label className='switch'>
                                            <input type = 'checkbox' className='switch-input' checked={installApp} onChange = {()=>{setInstallApp(!installApp); setOpenAvatar(false);}}/>
                                            <span className='switch-slider'></span>
                                        </label>
                                    </span>
                                </div>
                            </li>
                            <li className='listElement'>
                                <button  className='myProfile' onClick={logoutHandler} >Logout</button>
                            </li>
                        </ul>
                            </>}
                    </div>
                </div>
            </div>
            <div className={`drawer_block  ${drawerOpenClose}`} >
                <div className='modalOverlay' onClick={()=>setDrawerOpenClose("close")}></div>
                <div className={`drawer_content  ${drawerOpenClose}`}>
                    <div className='search_block_Header' >
                        <span onClick={()=>setDrawerOpenClose("close")} className=' close_button'>
                            <Closeicon />
                        </span>
                        <h2>Search Users</h2>
                    </div>
                    <div className='search_block_Gross'>
                        <div className='search_block'>
                            <input
                                className='updateInput'
                                placeholder="Search by name or email"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <button className='button' onClick={handleSearch}>Go</button>
                        </div>
                        {loading ? (
                            <ChatLoading />
                        ) : (
                            searchResult?.map((user) => (
                                <UserListItem
                                    key={user._id}
                                    user={user}
                                    handleFunction={() => accessChat(user._id)}
                                />
                            ))
                        )}
                        {loadingChat &&  <SpinnerCustom />}
                        {loadingChat && <ChatLoading />}
                    </div>
                </div>
            </div>
        </>
    )
}
export default SideDrawer
